import { ReactElement, useCallback } from 'react';
import { Link } from 'react-router-dom';
import iconNotifications from '../../../../assets/icon-notifications.svg';
import iconNotificationsNew from '../../../../assets/icon-notifications-new.svg';
import { routes } from '../../../constants';
import { markAllMessagesAsRead } from '../../../../shared/fetchApi';
import styles from '../Shell.module.scss';

type Props = {
    hasUnreadMessages: boolean;
    onMarkReadOptimistic: () => void;
    onAfterClick?: () => void;
    className?: string;
};

export const NachrichtenBell = ({ hasUnreadMessages, onMarkReadOptimistic, onAfterClick, className }: Props): ReactElement => {
    const onClick = useCallback(() => {
        onMarkReadOptimistic();
        onAfterClick?.();
        markAllMessagesAsRead();
    }, [onMarkReadOptimistic, onAfterClick]);

    return (
        <Link
            to={routes.nachrichten}
            className={[styles._notificationWrap, className].filter(Boolean).join(' ')}
            onClick={onClick}
            title="Nachrichten"
        >
            <img
                src={hasUnreadMessages ? iconNotificationsNew : iconNotifications}
                alt="Nachrichten"
                className={styles._notificationBell}
            />
        </Link>
    );
};
